module.exports = __webpack_public_path__ + "img/amex.099a371c.svg";